import ConversationItemType from 'models/conversation_item_type';

export default class NavigateToSidekickConversation {
  constructor(context) {
    this.context = context;
  }

  run({ item }) {
    if (item.contentType() !== ConversationItemType.MESSAGE_AUTOMATION_SUMMARY) {
      return;
    }

    const automationSessionId = item.content.automationSessionID;
    const url = `/sidekick/communication-sessions/${automationSessionId}`;
    window.open(url, '_blank');
  }
}
